import React from "react"

const DetailHeaderContent = ({ title, content }) => (
  <div>
    <div style={titleStyle}>{title}</div>
    <div style={contentStyle}>{content}</div>
  </div>
)

const titleStyle = {
  fontWeight: "bold"
}

const contentStyle = {
  marginBottom: "5px",
  marginTop: "5px",
  color: "gray"
}
export default DetailHeaderContent
